import { useContext, useMemo } from 'react';
import { createApiService } from '@core/api';
import { ServiceApiContext } from '@embed/components/Player3/contexts/serviceApi';
import { defaultApiHost } from '@src/helpers';
/** @returns the service API object from the context. */
export function useApi() {
    const api = useContext(ServiceApiContext);
    if (!api) {
        throw new Error('Service API is not set in the context');
    }
    return api;
}
/**
 * Use this hook if the service api is not provided from the context.
 * @returns the memoized service API object.
 */
export function useApiWithParams(params) {
    const api = useMemo(() => { var _a; return createApiService((_a = params === null || params === void 0 ? void 0 : params.api_host) !== null && _a !== void 0 ? _a : defaultApiHost); }, [params === null || params === void 0 ? void 0 : params.api_host]);
    return api;
}
